import { render, staticRenderFns } from "./PlatformInvoicesTable.vue?vue&type=template&id=138c33ee&"
import script from "./PlatformInvoicesTable.vue?vue&type=script&lang=js&"
export * from "./PlatformInvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports